import { render } from "./AuthorizationLayout.vue?vue&type=template&id=fe8806aa"
import script from "./AuthorizationLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizationLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__